import { render } from "./COVID19View.vue?vue&type=template&id=99f82606"
import script from "./COVID19View.vue?vue&type=script&lang=js"
export * from "./COVID19View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__